<!-- 交易规则 -->
<template>
  <div v-if="showRule" class="trade-rule">
    <!-- 顶部标题 -->
    <div class="top-title row">
      <div class="left-title">交易规则</div>
      <div class="right-title row" @click="goRules">
        <div>买入、卖出规则</div>
        <img :src="RIGHT_ARROW" class="arrow" />
      </div>
    </div>
    <!-- 进度条 -->
    <div class="process row">
      <div
        v-for="(item, index) in processList"
        :style="{ alignItems: alignList[index]}"
        :key="index"
        class="process-item">
        <div :class="basicInfo.isNewFund ? 'new-fund' : 'desc'">{{item.desc}}</div>
        <div class="time">{{item.time}}</div>
      </div>
      <div class="process-bar">
        <div class="color-bar"></div>
        <div class="dot-list row">
          <div
            v-for="(item, index) in processList"
            :style="{ alignItems: alignList[index]}"
            :key="index"
            class="dot-item">
            <div class="new-fund">{{item.text}}</div>
            <div class="dot-box">
              <div class="red-dot"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 提示 -->
    <div v-for="(tip, index) in tipList" :key="index" class="tips">{{tip.text}}</div>
    <!--特殊费率 -->
    <p class="ac-rate" v-if="isShowSpecialRate"><span>{{`该基金管理费以浮动方式提取。`
      }}</span><span class="more" @click="$goFundApp">了解详情</span></p>
    <!-- AC费率 -->
    <p class="ac-rate" v-if="isShowAcRate"><span>{{`基金A类C类区别仅在于收费方式的不同，持有${
      acRatePoint}天以上时，购买本基金A类费用低。`}}</span><span class="more"
      @click="$goFundApp">了解详情</span></p>
    <!-- 新发基金底部提示 -->
    <div v-if="basicInfo.isNewFund" class="bottom-fund-tip">
      <p v-for="(item, index) in fundTip" :key="index"
        ><b class="">{{item.title}}</b><span>{{item.content}}</span></p>
    </div>
    <div class="tags row">
      <div v-for="(tag, index) in tagList" :key="index" class="tag row" @click="$goFundApp">
        <img :src="tag.img" class="tag-icon" />
        <div :style="{color: tag.color}">{{tag.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@fund/basic-lib/dist/lib/date';

export default {
  name: 'trade-rule',

  props: {
    fundCode: {
      type: String,
      default: '',
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    showRule() {
      return !(this.basicInfo?.isETF);
    },
    // 交易规则进度条，区分新发
    processList() {
      return this.basicInfo.isNewFund
        ? this.productPeriodInfo || []
        : this.detailInfo?.tradeRule?.tradeProcessList || [];
    },
    // 新发基金交易规则
    productPeriodInfo() {
      const { startTime, endTime } = this.basicInfo;
      const cycle = this.detailInfo?.newFundBuyProgressInfo?.cycle;
      const rgEnd = this.detailInfo?.newFundBuyProgressInfo?.rgEnd;
      let temp = '募集期间';
      if (!this.judgeTime(startTime)) {
        temp = '募集开始后';
      } else if (this.judgeTime(startTime) && !this.judgeTime(endTime)) {
        const nowHour = new Date().getHours();
        if (rgEnd) {
          const endHour = formatDate(new Date(rgEnd.replace(/-/g, '/')), 'hh');
          const endDate = formatDate(new Date(rgEnd.replace(/-/g, '/')), 'hh:mm');
          temp = nowHour < endHour - 0 ? `今日${endDate}点前` : `今日${endDate}点后`;
        } else {
          temp = nowHour < 15 ? '今日15点前' : '今日15点后';
        }
      } else {
        temp = '募集期间';
      }
      return [
        {
          desc: '买入',
          time: temp,
          style: {
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          },
        },
        {
          desc: '确认份额',
          time: '基金成立后',
          style: {
            justifyContent: 'space-between',
            alignItems: 'center',
          },
        },
        {
          desc: '查看盈亏',
          time: '基金成立后',
          style: {
            justifyContent: 'space-between',
            alignItems: 'center',
          },
        },
        {
          desc: '开放卖出',
          time: '封闭期结束',
          text: this.$isEmpty(cycle) ? '' : `锁定期${cycle}`,
          style: {
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          },
        },
      ];
    },
    alignList() {
      return this.basicInfo?.isNewFund
        ? ['flex-start', 'center', 'center', 'flex-end']
        : ['flex-start', 'flex-start', 'flex-end'];
    },
    tipList() {
      return this.basicInfo?.isNewFund
        ? [] : this.detailInfo?.tradeRule?.tradeMarkList || [];
    },
    isShowSpecialRate() {
      return this.basicInfo?.isNewFund ? false : this.detailInfo?.isSpecialRate;
    },
    isShowAcRate() {
      if (this.basicInfo?.isNewFund) return false;
      const fundACRate = this.detailInfo?.fundAcRate?.acRateList || [];
      return fundACRate.filter((item) => item.isRg === '0').length > 0;
    },
    acRatePoint() {
      const fundACRate = this.detailInfo?.fundAcRate?.acRateList?.filter((item) => item.isRg === '0') || [];
      return fundACRate?.[fundACRate?.length - 1]?.tPoint1 || '--';
    },
    fundTip() {
      const newFundBuyProgressInfo = this.detailInfo?.newFundBuyProgressInfo || {};
      const cycle = newFundBuyProgressInfo?.cycle;
      return this.$isEmpty(cycle)
        ? [{
          title: '确认份额',
          content: '：新发基金若募集超过限额，可能会提前结束募集，或按末日比例配售，具体以确认份额为准；',
        }, {
          title: '期间收益',
          content: '：提交认购申请至认购结束期间，认购资金可享银行同期活期存款利息。',
        }] : [{
          title: '确认份额',
          content: '：新发基金若募集超过限额，可能会提前结束募集，或按末日比例配售，具体以确认份额为准；',
        }, {
          title: '期间收益',
          content: '：提交认购申请至认购结束期间，认购资金可享银行同期活期存款利息；',
        }, {
          title: '开放卖出',
          content: `：该基金单笔资金买入确认后锁定期${cycle}，到期后随时卖出。`,
        }];
    },
    tagList() {
      return this.detailInfo?.tradeRule?.tagList || [];
    },
  },

  methods: {
    goRules() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.jygz.click', '');
      this.$goFundApp();
    },
    // 判断当前时间是否超过目标时间
    judgeTime(targetTime) {
      if (this.$isEmpty(targetTime)) return false;
      const now = new Date().getTime();
      return now - new Date(targetTime.replace(/-/g, '/')).getTime() >= 0;
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.trade-rule {
  width: 100%;
  background-color: #ffffff;
  margin-top: 24px;
  box-sizing: border-box;
  padding: 40px 24px;
  border-radius: 12px;
  .top-title {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 40px;
    .left-title {
      font-size: 32px;
      font-weight: bold;
      color: #000000;
      .tip-icon {
        width: 28px;
        height: 28px;
        margin-left: 8px;
      }
    }
    .right-title {
      font-size: 28px;
      color: #666666;
      .arrow {
        width: 32px;
        height: 32px;
        margin-left: 8px;
      }
    }
  }
  .process {
    position: relative;
    margin-top: 64px;
    justify-content: space-between;
    .process-item {
      display: flex;
      flex-direction: column;
      flex: 1;
      .desc {
        color: #000000;
        font-size: 32px;
        line-height: 32px;
      }
      .new-fund {
        font-size: 24px;
        color: #666666;
        font-weight: 400;
        line-height: 32px;
      }
      .time {
        margin-top: 52px;
        line-height: 28px;
        font-size: 28px;
        color: #666666;
        font-weight: 400;
      }
    }
    .process-bar {
      position: absolute;
      top: 48px;
      left: 0;
      right: 0;
      .color-bar {
        margin-top: 7px;
        width: 100%;
        height: 6px;
        background-color: rgba(250, 89, 20, 0.2);
      }
      .dot-item {
        display: flex;
        flex-direction: column;
        flex: 1;
        position: relative;
        .new-fund {
          position: absolute;
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #FB7F4A;
          letter-spacing: 0;
          font-weight: 400;
          left: 0;
          right: 0;
          top: -28px;
          text-align: center;
        }
        .dot-box {
          width: 20px;
          height: 20px;
          background-color: #ffffff;
          margin-top: -13px;
          .red-dot {
            margin: 2px;
            width: 16px;
            height: 16px;
            border-radius: 16px;
            background-color: #FA5914;
          }
        }
      }
    }
  }
  .bottom-fund-tip {
    margin-top: 32px;
    background: #F5F5F5;
    border-radius: 16px;
    padding: 16px 24px;
    p {
      margin: 0 0 36px;
      font-family: PingFangSC-Regular;
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
    }
    p:last-child {
      margin: 0;
    }
  }
  .tips {
    font-size: 28px;
    color: #999999;
    margin-top: 32px;
  }
  .ac-rate {
    margin: 24px 0 0;
    font-size: 28px;
    line-height: 40px;
    color: #999999;
    .more {
      color: #008aff;
    }
  }
  .tags {
    margin-top: 24px;
    font-size: 28px;
    color: #999999;
    justify-content: space-between;
    .tag-icon {
      width: 28px;
      height: 28px;
      margin-right: 8px;
    }
  }
}
</style>
